import Select from './Select';


Select.install = function(Vue) {
  Vue.component(Select.name, Select);
};

export default Select;
